export default {
  ResetCustomReport: 'ResetCustomReport',
};
